"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * DOM Matrix.
 *
 * TODO: Not fully implemented.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMMatrix
 */
var DOMMatrix = /** @class */ (function () {
    function DOMMatrix() {
        this.is2D = false;
        this.isIdentity = false;
    }
    return DOMMatrix;
}());
exports.default = DOMMatrix;
//# sourceMappingURL=DOMMatrix.js.map